class GetFullName {
	static userFullName = ({ first_name = 'NA', last_name = '' }, separator = ' ') =>
		`${first_name}${separator}${last_name || ''}`;

	static salesmanFullName = ({ salesman_first_name = 'NA' }) => `${salesman_first_name}`;

	static sourceSalesmanFullName = (
		{ source_salesman_first_name = 'NA', source_salesman_last_name = '' },
		separator = ' '
	) => `${source_salesman_first_name}${separator}${source_salesman_last_name || ''}`;

	static delegatedSalesmanFullName = ({ delegated_salesman_first_name = 'NA' }) =>
		`${delegated_salesman_first_name}`;

	static fromSalesmanFullName = ({ from_salesman_first_name = 'NA' }) =>
		`${from_salesman_first_name}`;

	static toSalesmanFullName = ({ to_salesman_first_name = 'NA' }) => `${to_salesman_first_name}`;
}

export default GetFullName;
